let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3BBZq")).then(() => parcelRequire('vo0CC'));